import Floatbar from "@app/components/Floatbar";
import { useSetToast } from "@app/components/Toast";
import { Button } from "@design-system/Inputs/Button";

import { useQuestionsUpdate } from "@app/screens/ExternalQuestionnaires/externalQuestionnaire/data";
import { QuestionActivation } from "@generated/client/graphql";
import { useInactiveQuestionsModalTranslations } from "./i18n";

export const ActionBar = ({
    questionnaireId,
    questionsIds,
    unset,
}: {
    questionnaireId: string;
    questionsIds: string[];
    unset: () => void;
}) => {
    const { t, keys } = useInactiveQuestionsModalTranslations();
    const { updateQuestions, isPending } = useQuestionsUpdate(questionnaireId);

    const { setToastSuccess, setToastError } = useSetToast();

    const onSetRelevant = () => {
        updateQuestions(
            {
                ids: questionsIds,
                input: {
                    activation: QuestionActivation.Active,
                },
            },
            {
                onSuccess: () => {
                    setToastSuccess(
                        t(keys.question_table_action_set_relevant_success),
                    );
                    unset();
                },
                onError: () => {
                    setToastError(
                        t(keys.question_table_action_set_relevant_error),
                    );
                },
            },
        );
    };

    return (
        <Floatbar
            unset={unset}
            text={t(keys.question_table_action_set_relevant, {
                count: questionsIds.length,
            })}
            open={questionsIds.length > 0}
            primary={
                <Button size="sm" onClick={onSetRelevant} loading={isPending}>
                    {t(keys.question_table_action_apply)}
                </Button>
            }
        />
    );
};
